import { Dispatch, PropsWithChildren, SetStateAction } from "react"
import { useAfterPaintEffect } from "@bundles/parts/components/ListV2/helpers"
import { ArticlesContext, useArticlesContext } from "@bundles/parts/components/ListV2/ContextProvider/Articles"
import { useFastCalculatorList } from "./useFastCalculatorList"
import { FastCalculatorArticleData } from "../../../models"

export type FastCalculatorListProviderProps = PropsWithChildren<{
    setHasRendered: Dispatch<SetStateAction<boolean>>
}>

export function FastCalculatorListProvider({ children, setHasRendered }: FastCalculatorListProviderProps) {
    const fastCalculatorListData = useFastCalculatorList()

    useAfterPaintEffect(() => {
        setHasRendered(!!fastCalculatorListData.articles)
    }, [fastCalculatorListData.isEnabled])

    return <ArticlesContext.Provider value={fastCalculatorListData}>{children}</ArticlesContext.Provider>
}

export function useFastCalculatorListContext<TContext extends FastCalculatorArticleData>(): TContext
export function useFastCalculatorListContext<TContext extends FastCalculatorArticleData, TReturnType>(
    selector: (value: TContext) => TReturnType
): TReturnType
export function useFastCalculatorListContext<TContext extends FastCalculatorArticleData, TReturnType>(
    selector?: (value: TContext) => TReturnType
): TReturnType | TContext {
    return useArticlesContext(selector as never)
}
